import { createStore, applyMiddleware, compose as composeRedux } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

export type RootState = ReturnType<typeof rootReducer>;
export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
	key: 'courses',
	storage,
	stateReconciler: autoMergeLevel2,
	blacklist: ["auth"]
};
const compose =
	process.env.NODE_ENV === 'production' ? composeRedux : composeWithDevTools;
const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);
// @ts-ignore
export const store = createStore(
	persistedReducer,
	// @ts-ignore
	compose(applyMiddleware(sagaMiddleware)),
);

export const persistor = persistStore(store);
sagaMiddleware.run(rootSaga);
